import { useMutation, useQueryClient } from "@tanstack/react-query";
import { switchToSelfSession } from "../../api/delegation";
import { invalidateDelegationQueries } from "./delegationQueryKeys";

export const useSwitchToSelfSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: switchToSelfSession,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["userInfo"] });
      invalidateDelegationQueries(queryClient);
      window.location.href = "/";
    },
  });
};
